import { councilDeviceApi } from "@/lib/api"
import type { ApiResponseDeviceDetailDTO, DeviceDetailDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetDeviceDetail = (councilId: string, deviceId: string) => {
  return useQuery({
    queryKey: ["deviceDetail", councilId, deviceId],
    queryFn: async () => {
      const response = await councilDeviceApi.getCouncilDevice(councilId, deviceId)
      return (response.data as ApiResponseDeviceDetailDTO).data as DeviceDetailDTO
    },
  })
}

export default useGetDeviceDetail
